import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getMoedasEstrangeiras(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("moedasEstrangeiras/access/listaDistinct", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getMoedasEstrangeirasPorPeriodo(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("moedasEstrangeiras/access/listaPorPeriodo", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getIndices(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
                dados.pagina = 1;
                dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("moedasEstrangeiras/access/listar", dados).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    },
    getIndice(context, dados) {
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("moedasEstrangeiras/access/obter", {ID_MOEDA_ESTRANGEIRA: dados.id, componente: dados.componente}).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    },
    getIndicePorDescricaoResumida(context, descricao) {
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("moedasEstrangeiras/access/obterPorDescricaoResumida", {DESCRICAO_ABREVIADA: descricao}).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    },
    deleteIndice(context, dados) {
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("moedasEstrangeiras/access/excluir", {ID_MOEDA_ESTRANGEIRA: dados.id, componente: dados.componente}).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    },
    postIndice(context, dados) {
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("moedasEstrangeiras/access/salvar", dados).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};